/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './addReservedHandle.defs.js'
export { main as default } from './addReservedHandle.defs.js'
